export function  getUserId() {
  return sessionStorage.getItem("userid");
}
export function  getToken() {
  return sessionStorage.getItem("token");
}

export function  getLanguage() {
  return localStorage.getItem("I18n")?localStorage.getItem("I18n"):"zh-CN"
}



// WEBPACK FOOTER //
// ./src/utils/auth.js